import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import services from '../../services';
import { toast } from 'react-toastify';
import axios from 'axios';
import Automations from './Automations';
import DeletePopup from '../DeletePopup';

const AllAutomation = ({ show, onHide, step, setStep, setAutomations, editId, setEditId }) => {
    const [automations, setAutomationsState] = useState([]);
    const [existautomation, setExistautomation] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [deletemodal, setDeletemodal] = useState(false);
    const [boardList, setBoardList] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const getAllAutomation = async () => {
        setLoading(true);
        try {
            const response = await services.automations.GET_ALL_AUTOMATIONS(`isColumnAutomation=false`);

            if (response) {
                setAutomationsState(response || []);
                if (response?.data?.data?.length > 0) {
                    setExistautomation(true);
                }
            }
        } catch (e) {
            toast.error('Failed to fetch automations');
            setAutomationsState([]);
        }
        setLoading(false);
    };

    useEffect(() => {
        getAllAutomation();
    }, []);

    useEffect(() => {
        const getUserById = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser`);
                if (response?.data?.data?.users) {
                    setUserList(response?.data?.data?.users);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };

        const getGmailUsers = async () => {
            try {
                const response = await services.email.Get_The_Linked_Email();
                if (response?.data) {
                    const gmailOptions = response.data.map((item) => ({
                        value: item.id,
                        label: item.email,
                    }));
                    setFilterList(gmailOptions);
                }
            } catch (error) {
                console.error('Error fetching Gmail users:', error);
            }
        };

        getUserById();
        getGmailUsers();
        getAllBoardDateTable();
    }, []);

    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();

            if (response) {
                setBoardList(response?.data?.data);


                const boardNameOptions =
                    response?.data?.data?.map((board) => ({
                        label: board.boardName,
                        value: board.id,
                    })) || [];
                setBoardName(boardNameOptions);

                const boardColumnsMap = {};
                response?.data?.data?.forEach((board) => {
                    if (board.BoardLists && board.BoardLists.length > 0) {
                        boardColumnsMap[board.id] = board.BoardLists.map((column) => ({
                            id: column.id,
                            name: column.coloum,
                            color: column.colour,
                            sequence: column.sequence,
                        }));
                    }
                });

                setColumnList(boardColumnsMap);
            }
        } catch (error) {
            console.error('Error fetching board date table:', error);
        }
    };

    const getUserNameById = (id) => {
        const user = userList.find((u) => u.id === id);
        return user ? user.name : 'N/A';
    };

    const getBoardNameById = (id) => {
        const board = boardList.find((b) => b.id === id);
        return board ? board.boardName : 'N/A';
    };

    const getColumnNameById = (boardId, columnId) => {
        if (columnList[boardId]) {
            const column = columnList[boardId].find((col) => col.id === columnId);
            return column ? column.name : 'N/A';
        }
        return 'N/A';
    };

    const getColumnsByBoardId = (boardId) => {
        return columnList[boardId] || [];
    };

    const getBoardIdFromAutomation = (auto) => {

        if (auto.type === 'new') {
            const createOnListAction = auto.action?.find((action) => action.action === 'createOnList');
            return createOnListAction?.boardId;
        }

        return auto.condition?.find((c) => c.operand === 'board')?.value;
    };

    const handleEdit = (id) => {
        setStep(2);
        setAutomations(true);
        setEditId(id);
    };
    const handleDelete = (id) => {
        setDeleteId(id);
        setDeletemodal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            await services.automations.DELETE_BY_ID_AUTOMATIONS(deleteId);
            toast.success('Automation deleted successfully');
            setDeletemodal(false);
            setDeleteId(null);
            getAllAutomation();
        } catch (e) {
            toast.error('Failed to delete automation');
        }
    };
    const formatConditions = (
        conditions = [],
        boardList = [],
        columnList = {},
        automationType = '',
        gmailUserId = '',
    ) => {
        if (!Array.isArray(conditions) || conditions.length === 0) {
            return [];
        }
        const formattedConditions = conditions.map((cond) => {
            let label = '';
            let value = cond.value;

            switch (cond.operand) {
                case 'title':
                    label = 'Title';
                    break;
                case 'listName':
                    label = 'List';

                    for (const boardId in columnList) {
                        const column = columnList[boardId]?.find((col) => col.id === cond.value);
                        if (column) {
                            value = column.name;
                            break;
                        }
                    }
                    break;
                case 'board':
                    label = 'Board';
                    const board = boardList.find((b) => b.id === cond.value);
                    if (board) {
                        value = board.boardName;
                    }
                    break;
                case 'assignee':
                    label = 'Assignee';

                    if (Array.isArray(cond.value)) {

                        const userIds = cond.value.map((item) => item.entityId).filter(Boolean);
                        const userNames = userIds.map((userId) => getUserNameById(userId));
                        value = userNames.join(', ');
                    } else if (cond.value && typeof cond.value === 'object' && cond.value.entityId) {

                        value = getUserNameById(cond.value.entityId);
                    } else if (typeof cond.value === 'string') {

                        value = getUserNameById(cond.value);
                    }
                    break;
                case 'subject':
                    label = 'Subject';
                    break;
                case 'sender':
                    label = 'From email address';
                    break;
                case 'recipient':
                    label = 'To email address';
                    break;
                case 'customerWaiting':
                    label = 'the customer has been waiting';
                    break;
                case 'customerNotResponding':
                    label = 'the team has been waiting';
                    break;
                default:
                    label = cond.operand;
            }

            let operatorText = '';
            switch (cond.operator) {
                case 'equals':
                    operatorText = 'equals';
                    break;
                case 'doesNotContain':
                    operatorText = 'does not contain';
                    break;
                case 'contains':
                    operatorText = 'contains';
                    break;
                case 'moreThanMins':
                    operatorText = 'more than (minutes)';
                    break;
                case 'moreThanHrs':
                    operatorText = 'more than (hours)';
                    break;
                case 'moreThanDays':
                    operatorText = 'more than (days)';
                    break;
                default:
                    operatorText = cond.operator;
            }

            return `${label} ${operatorText} "${value}"`;
        });


        if (automationType === 'new' && gmailUserId) {
            const gmailUser = filterList.find((user) => user.value === gmailUserId);
            if (gmailUser) {
                formattedConditions.unshift(gmailUser.label);
            }
        }

        return formattedConditions.join(', ');
    };

    const formatActions = (actions = []) => {
        if (!Array.isArray(actions) || actions.length === 0) {
            return [];
        }
        return actions
            .map((act) => {
                let actionText = '';

                switch (act.action) {
                    case 'createOnList':
                        const boardName = getBoardNameById(act.boardId);
                        const columnName = getColumnNameById(act.boardId, act.entityId);
                        actionText = `Create task on list: ${columnName}`;
                        break;

                    case 'assignTo':
                        const userName = getUserNameById(act.entityId);
                        actionText = `Assign to ${userName}`;
                        break;

                    case 'assignToRoundRobin':
                        if (act.entityIds && Array.isArray(act.entityIds)) {
                            const userNames = act.entityIds.map((user) => getUserNameById(user.entityId));
                            actionText = `Assign with round robin to ${userNames.join(', ')}`;
                        } else if (act.entityId) {

                            const userName = getUserNameById(act.entityId);
                            actionText = `Assign with round robin to ${userName}`;
                        } else {
                            actionText = 'Assign with round robin';
                        }
                        break;

                    case 'unassign':
                        actionText = 'Unassign task';
                        break;

                    case 'markComplete':
                        actionText = 'Mark task as complete';
                        break;

                    case 'markIncomplete':
                        actionText = 'Mark task as incomplete';
                        break;

                    case 'moveToNext':
                        actionText = 'Move task to next list';
                        break;

                    case 'moveToPreviousList':
                        actionText = 'Move task to previous list';
                        break;

                    case 'sendOverdueAlert':
                        if (act.message) {
                            actionText = `Send overdue alert: "${act.message}"`;
                        } else {
                            actionText = 'Send overdue alert';
                        }
                        break;

                    case 'sendUpcomingAlert':
                        if (act.message) {
                            actionText = `Send upcoming alert: "${act.message}"`;
                        } else {
                            actionText = 'Send upcoming alert';
                        }
                        break;

                    case 'sendNotificationTo':
                        if (act.entityId) {
                            const userName = getUserNameById(act.entityId);
                            actionText = `Send notification to ${userName}`;
                        } else {
                            actionText = 'Send notification';
                        }
                        break;

                    case 'setSlaAlertTag':
                        if (act.entityValue && Array.isArray(act.entityValue)) {
                            actionText = `Set SLA Alert Tag: ${act.entityValue.join(', ')}`;
                        } else {
                            actionText = 'Set SLA Alert Tag';
                        }
                        break;

                    case 'subEmailInbox':
                        actionText = 'Skip inbox processing';
                        break;

                    case 'emailInbox':
                        if (act.hasReply !== undefined) {
                            const status = act.hasReply === true ? 'skip' : 'not skip';
                            actionText = `Email inbox (hasReply: ${status})`;
                        } else {
                            actionText = 'Email inbox';
                        }
                        break;

                    default:
                        actionText = act.action;
                }

                return actionText;
            })
            .join(', ');
    };

    const typeLabelMap = {
        itemAdded: 'Item Added to List',
        new: 'New Email Received',
        noReplyFromCustomer: 'No Reply From Customer',
        noReplyToCustomer: 'No Reply To Customer',

        default: 'Unknown Type',
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            minHeight="400px"
            style={{ scrollbarWidth: 'none' }}
        >
            <Modal.Header closeButton>
                <h2 className="text-[28px] pt-[1vw] px-[1.4vw] font-normal font-google">Automations</h2>
            </Modal.Header>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '16px 16px 0 16px',
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>

                    </div>
                </div>
            </div>

            <div className="px-8  min-h-[300px] max-h-[200px] overflow-y-auto overflow-x-auto scrollbar-hide">
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'separate',
                        borderSpacing: 0,
                        background: 'white',
                        overflow: 'hidden',
                        height: '80%',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.03)',
                    }}
                >
                    {automations.length > 0 && (
                        <thead>
                            <tr style={{ borderBottom: '2px solid #F0F0F0', textAlign: 'left', background: '#F8FAFB' }}>
                                <th style={{ padding: '14px 10px', fontWeight: 600, color: '#222', fontSize: 16 }}>
                                    Board
                                </th>
                                <th style={{ padding: '14px 10px', fontWeight: 600, color: '#222', fontSize: 16 }}>
                                    Type
                                </th>
                                <th style={{ padding: '14px 10px', fontWeight: 600, color: '#222', fontSize: 16 }}>
                                    Conditions
                                </th>
                                <th style={{ padding: '14px 10px', fontWeight: 600, color: '#222', fontSize: 16 }}>
                                    Actions
                                </th>
                                <th
                                    style={{ padding: '14px 10px', fontWeight: 600, color: '#222', fontSize: 16 }}
                                    className="text-right"
                                ></th>
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan={5}
                                    style={{ textAlign: 'center', padding: 40, color: '#aaa', fontSize: 18 }}
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : automations.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={5}
                                    style={{
                                        textAlign: 'center',
                                        padding: 40,
                                        color: '#aaa',
                                        fontSize: 24,
                                        fontFamily: 'google',
                                    }}
                                >
                                    Create your Custom automation
                                </td>
                            </tr>
                        ) : (
                            automations.map((auto) => (
                                <tr key={auto.id} style={{ borderBottom: '1px solid #F5F5F5', background: '#fff' }}>
                                    <td style={{ padding: '14px 10px', color: '#222', fontSize: 15 }}>
                                        {getBoardNameById(getBoardIdFromAutomation(auto))}
                                    </td>
                                    <td style={{ padding: '14px 10px', color: '#222', fontSize: 15 }}>
                                        {typeLabelMap[auto.type] || typeLabelMap.default}
                                    </td>

                                    <td style={{ padding: '14px 10px', color: '#222', fontSize: 15 }}>
                                        {formatConditions(
                                            auto.condition,
                                            boardList,
                                            columnList,
                                            auto.type,
                                            auto.when?.gmailUserId,
                                        )}
                                    </td>
                                    <td style={{ padding: '14px 10px', color: '#222', fontSize: 15 }}>
                                        {formatActions(auto.action)}
                                    </td>
                                    <td style={{ padding: '14px 10px', textAlign: 'right' }}>
                                        <div
                                            className="flex items-center gap-2"
                                            style={{ display: 'flex', justifyContent: 'flex-end' }}
                                        >
                                            <button
                                                className="bg-gray-100 border border-gray-200 text-gray-800 rounded-md px-4 py-1.5 text-sm hover:bg-gray-200 transition"
                                                onClick={() => handleEdit(auto.id)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                style={{
                                                    background: '#F5F5F5',
                                                    border: '1px solid #E0E0E0',
                                                    color: '#222',
                                                    borderRadius: '6px',
                                                    padding: '6px 16px',
                                                    fontSize: 15,
                                                    marginRight: 8,
                                                    cursor: 'pointer',
                                                    transition: 'background 0.2s',
                                                }}
                                                onClick={() => handleDelete(auto.id)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <Modal.Footer>
                <button
                    className="bg-blue-500 font-google text-white font-bold py-2 px-4 font-normal rounded focus:outline-none focus:shadow-outline"
                    onClick={() => {
                        setStep(2);
                        setEditId(null);
                        setAutomations(true);
                    }}
                >
                    Create
                </button>
            </Modal.Footer>

            {automations && step === 2 && (
                <Automations
                    show={automations}
                    setAutomations={setAutomations}
                    onHide={onHide}
                    boardName={boardName}
                    gmailUsers={filterList}
                    step={step}
                    setStep={setStep}
                    editId={editId}
                    setEditId={setEditId}
                    getAllAutomation={getAllAutomation}
                />
            )}

            <DeletePopup
                open={deletemodal}
                title="Are you sure you want to delete this automation?"

                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletemodal(false)}
                confirmLabel="YES, I'M SURE"
                cancelLabel="NO"
            />
        </Modal>
    );
};

export default AllAutomation;
